import { useSelector } from '@tunasong/redux'
import { CSP } from '@tunasong/ui-lib'
import { vendorsCSP } from '@tunasong/vendor'
import type { FC } from 'react'

function getOrigin(urlString: string): string | null {
  try {
    return new URL(urlString).origin
  } catch {
    return null
  }
}

/** Render CSP after user config is loaded so external tool origins are included in frame-src.
 * CSP meta tags can only become more restrictive once set, so we must include all
 * origins in the first render.
 *
 * Uses useSelector directly (not useUserConfig) so it can render in main.tsx
 * inside HelmetProvider + Redux Provider, without needing GlobalAppContext. */
export const DynamicCSP: FC = () => {
  const externalTools = useSelector(state => state.config.userConfig.externalTools) ?? []
  const hasLoaded = useSelector(state => state.config.userConfigLoaded)

  const externalOrigins = externalTools.map(t => getOrigin(t.url)).filter(Boolean) as string[]
  const frameSrc = [...vendorsCSP.frameSrc, ...externalOrigins]

  if (!hasLoaded) {
    return null
  }

  return <CSP domainName="tunasong.com" frameSrc={frameSrc} />
}
